import { Field, LinkField, Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { useContext } from 'react';
import { contextType, HeaderContext } from './Header';

import Link from 'components/helpers/Link/Link';

type SubnavigationTitleProps = {
  title: Field<string>;
  link: LinkField;
  isOpen: boolean;
  parentId: string;
  datasourceLanguage?: string;
};

const SubnavigationTitle = (props: SubnavigationTitleProps): React.JSX.Element | null => {
  const { parentId } = props;
  const { openSubNav, resetMobileMenu, setOpenSubNav } = useContext(HeaderContext) as contextType;
  const { sitecoreContext } = useSitecoreContext();

  const handleFocus: React.FocusEventHandler<HTMLElement> = () => {
    if (openSubNav !== parentId) {
      setOpenSubNav(parentId);
    }
  };

  if (props.link?.value?.href?.length && props.title?.value != '') {
    return (
      <h5>
        <Link
          field={props.link}
          data-id="sublink"
          tabIndex={props.isOpen ? 0 : -1}
          showLinkTextWithChildrenPresent={false}
          lang={props.datasourceLanguage}
          onClick={() => {
            resetMobileMenu();
            setOpenSubNav(null);
          }}
          onFocus={handleFocus}
        >
          <Text field={props.title} encode={sitecoreContext.pageEditing} />
        </Link>
      </h5>
    );
  } else if (props.title?.value != '') {
    return <Text field={props.title} tag="h5" encode={sitecoreContext.pageEditing} />;
  } else {
    return null;
  }
};

export default SubnavigationTitle;
